"use strict";

module.exports = {
    "footer": {
        "about": "Про компанію",
        "about-url": "//company.yandex.ru",
        "advert": "Реклама",
        "advert-url": "//advertising.yandex.ua/kupislova.xml?advertising",
        "apps": "Мобільні програми",
        "apps-url": "//mobile.yandex.ru",
        "stat": "Статистика",
        "termsofuse": "Ліцензія на пошук",
        "termsofuse-url": "//legal.yandex.ru/termsofuse/"
    }
};